const isRentlioPayEnabled = () => {
  return window.initialBookingEngineData?.isRentlioPayFeatureFlagEnabled
}

export default isRentlioPayEnabled
